import(/* webpackMode: "eager" */ "/Users/sammyfung/projects/2026 HKOSCon/2026/src/components/footer/footer.scss");
;
import(/* webpackMode: "eager" */ "/Users/sammyfung/projects/2026 HKOSCon/2026/src/app/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/sammyfung/projects/2026 HKOSCon/2026/src/components/navbar/Navbar.jsx");
